import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CompareTable } from "../Pill";
import { COMPARE_COLUMNS, HOME_COMPARE } from "../../mock";
import { useContent } from "../../context/ContentContext";

export default function MethodComparison() {
  const { c } = useContent();
  const m = c.methodComparison;
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
        <p className="eyebrow">{m.eyebrow}</p>
        <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{m.title}</h2>
        <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-500">{m.description}</p>
        <p className="mt-6 max-w-4xl rounded-xl bg-slate-50 p-4 text-[13px] leading-relaxed text-slate-500">{m.disclaimer}</p>

        <div className="mt-8">
          <CompareTable columns={COMPARE_COLUMNS} rows={HOME_COMPARE} />
        </div>

        <div className="mt-8">
          <Link to="/compare" className="group inline-flex items-center gap-2 rounded-xl bg-[var(--brand-blue)] px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)]">
            {m.cta}
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
